import _extends from "@babel/runtime/helpers/extends";
import { BoxSelect, EmailSuggestion } from '@wkda/funnel-components';
import { Checkbox, Select, TextInput } from '@wkda/styleguide';
import cx from 'classnames';
import React from 'react';
// these functions will be adapters for the components
// we use for the fields
export function selectFieldRenderer(_ref) {
  let {
    input,
    meta,
    placeholder,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Select, _extends({}, input, {
    className: cx('carlead-creation-field__control carlead-creation-field--select', className),
    id: input.name,
    placeholderOption: placeholder
  }, props));
}
export function boxSelectRenderer(_ref2) {
  let {
    input,
    meta,
    ...props
  } = _ref2;
  const {
    type: _type,
    ...restInput
  } = input;
  return /*#__PURE__*/React.createElement(BoxSelect, _extends({}, restInput, props));
}
export function checkboxRenderer(_ref3) {
  let {
    input,
    meta,
    ...props
  } = _ref3;
  const {
    type: _type,
    ...restInput
  } = input;
  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    id: input.name
  }, restInput, props));
}
export function textInputRenderer(_ref4) {
  let {
    input,
    meta,
    className = '',
    ...props
  } = _ref4;
  const {
    type: _type,
    ...restInput
  } = input;
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    bare: true,
    id: input.name,
    className: cx('carlead-creation-field__control', className)
  }, restInput, props));
}
export function emailWithSuggestionInputRenderer(_ref5) {
  let {
    input,
    meta,
    emailSuggestionEnabled,
    onSuggestion = () => {},
    ...props
  } = _ref5;
  return /*#__PURE__*/React.createElement(React.Fragment, null, textInputRenderer({
    input,
    meta,
    type: 'email',
    ...props
  }), emailSuggestionEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmailSuggestion, {
    email: input.value,
    setEmail: email => {
      onSuggestion(email);
    }
  })) : null);
}